'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.home', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general', {
        url: '',
        parent: 'master',
        abstract: true,
        views: {
            'menu@root': {
                template: '<site-nav navigation-data="$resolve.navigationData"></site-nav>'
            }
        },
        resolve: {
            navigationData: ["categoryService", "sellerService", "$q", function navigationData(categoryService, sellerService, $q) {
                var promises = [];
                promises.push(categoryService.getMenuCategories());
                promises.push(sellerService.getAllForMenu());

                return $q.all(promises).then(function (results) {
                    return {
                        categories: results[0],
                        sellers: results[1]
                    };
                });
            }],
            parentState: ["$state", function parentState($state) {
                return $state.get('general');
            }]
        },
        ncyBreadcrumb: {
            skip: true // Never display this state in breadcrumb.
        }
    }).state('home', {
        url: '',
        parent: 'general',
        views: {
            'main@root': {
                component: 'home'
            }
        },
        ncyBreadcrumb: {
            skip: true // Never display this state in breadcrumb.
        }
    });
}]).component('home', _home2.default);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/home/index.js
// module id = 937
// module chunks = 0